@if(!loading) {
<div class="container-fluid p-3 h-100">
  <!-- <div class="suite-div">
    <span class="general-text-2-1">Test Suite</span>
    <div class="suite">
      <span class="header-12-1"> {{ suite }}</span>
    </div>
  </div> -->

  <div class="mt-3 w-100 card card-coverage rounded mx-auto pb-5 align-items-center d-flex position-relative">
    <span class="title-float"> {{ suite }}</span>
    <div class="d-flex my-1 col-md-9 title-legend justify-content-center align-items-center">
      <span class="header-coverage"> Code Coverage </span>
      <span class="header-coverage-high"> {{ coverage }}% </span>
    </div>
    <div>
      <app-pie-chart
        [isDefect]="true"
        [chartType]="'pie'"
        [data]="chartData"
        [backgroundColors]="bgColors"
      ></app-pie-chart>
    </div>
  </div>
</div>
} @else {
<app-loading [text]="'Loading data'"></app-loading>
}
